export default __webpack_public_path__ + "static/media/IMG-20240708-WA0002.21e3b68e.jpg";